'use strict';
import React, { Component } from 'react';
import { View } from 'react-native';

import ReactDOM from 'react-dom';
import AiHelperComp from '@qnpm/f_ai_helper';

class AiHelper extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const dom = ReactDOM.findDOMNode(this);
        setTimeout(() => {
            this.initAiHelper(dom);
        }, 1000);
    }

    initAiHelper = async (dom) => {
        const { param = {} } = this.props || {};
        let appInfo = {};
        if (window.appInfoService) {
            appInfo = await window.appInfoService.getInfo();
        }
        this.aiHelper = new AiHelperComp(dom, {
            invokeSource: 'INNER_BARGAIN_FLIGHT_LOW_PRICE_LIST_BALL',
            param,
            appInfo,
            onCreate: (data) => {
                this.aiHelperInstance = data;
                if (global.__low_price_home) {
                    global['__low_price_home'].aiHelperInstance = data;
                }
            }
        });
    };

    render() {
        const { param = {} } = this.props || {};
        const { isInter } = param || {};

        return (
            <View style={{zIndex: 200, display: !isInter ? 'flex' : 'none'}}/>
        )
    }
}

export default AiHelper;
